import { Injectable } from '@angular/core';
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PreviousRouteService {

  private previousUrl: string;
  private currentUrl: string;
  private continueShoppingUrl: string;

  constructor(
      private router: Router,
      @Inject(PLATFORM_ID) private platformId: object
  ) {
    this.currentUrl = this.router.url;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;

      }

      if (event instanceof NavigationStart && isPlatformBrowser(this.platformId)) {
        const pathNameParts = location.pathname.split('/');
        if (pathNameParts.length === 4 && pathNameParts[1] === 'courses') {
          this.continueShoppingUrl = '/courses' + location.toString().split('/courses')[1];
        }
      }

    });
  }

  public getPreviousUrl() {
    return this.previousUrl;
  }

  public getContinueShoppingUrl() {
    return this.continueShoppingUrl;
  }
}
